<template>
  <form class="form" @submit.prevent="saveChanges">

    <div class="kt-form kt-form--label-right">

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label"></label>
        <div class="col-xl-4 col-lg-6">
          <h5>Change Or Recover Your Password:</h5>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">Current password <BaseRequiredField /></label>
        <div class="col-xl-4 col-lg-6">
          <input
            type="password"
            class="form-control"
            :class="{ 'is-invalid': $v.currentPassword.$error }"
            v-model.trim="currentPassword"
            @blur="$v.currentPassword.$touch()">
          <template v-if="$v.currentPassword.$error">
            <div class="invalid-feedback" v-if="!$v.currentPassword.required"><font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" /> Current password is required</div>
          </template>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label"><font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" /> New password <BaseRequiredField /></label>
        <div class="col-xl-4 col-lg-6">
          <input
            type="password"
            class="form-control"
            :class="{ 'is-invalid': $v.newPassword.$error }"
            v-model.trim="newPassword"
            @blur="$v.newPassword.$touch()"
            autocomplete="false">
          <template v-if="$v.newPassword.$error">
            <div class="invalid-feedback" v-if="!$v.newPassword.required"><font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" /> New password is required</div>
          </template>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-xl-4 col-lg-3 col-form-label">Re-type new password <BaseRequiredField /></label>
        <div class="col-xl-4 col-lg-6">
          <input
            type="password"
            class="form-control"
            :class="{ 'is-invalid': $v.confirmNewPassword.$error }"
            v-model.trim="confirmNewPassword"
            @blur="$v.confirmNewPassword.$touch()"
            autocomplete="false">
          <template v-if="$v.confirmNewPassword.$error">
            <div class="invalid-feedback" v-if="!$v.confirmNewPassword.required"><font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" /> Re-type new password is required</div>
            <div class="invalid-feedback" v-if="!$v.confirmNewPassword.sameAsPassword"><font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" /> Passwords must match</div>
          </template>
        </div>
      </div>

    </div>

    <div class="text-center">
      <div class="kt-separator kt-separator--border-dashed"></div>
      <BaseButton type="submit" classButton="btn btn-danger btn-bold btn-wide" :disabled="$v.$invalid || isLoading">
        <span>Save changes</span>
        <font-awesome-icon :icon="['fas', 'spinner']" spin class="ml-1" v-if="isLoading" />
      </BaseButton>
    </div>

  </form>
</template>

<script>
import NProgress from 'nprogress'
import { required, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'ChangePassword',
  data () {
    return {
      isLoading: false,
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: ''
    }
  },
  validations: {
    currentPassword: { required },
    newPassword: { required },
    confirmNewPassword: { required, sameAsPassword: sameAs('newPassword') }
  },
  methods: {
    saveChanges () {
      this.$v.$touch()
      if (!this.$v.$invalidad) {
        const form = {
          currentPassword: this.currentPassword,
          newPassword: this.newPassword,
          confirmNewPassword: this.confirmNewPassword
        }
        NProgress.start()
        this.isLoading = true
        this.$store
          .dispatch('profile/saveChangePassword', form)
          .then(() => {
            this.isLoading = false
            this.resetForm()
            NProgress.done()
            this.$notification.success('Changes saved successfully!')
          })
          .catch((error) => {
            this.isLoading = false
            NProgress.done()
            this.$notification.error(error.response.data.message)
          })
      }
    },
    resetForm () {
      this.currentPassword = ''
      this.newPassword = ''
      this.confirmNewPassword = ''
      this.$v.$reset()
    }
  }
}
</script>
